export default "__VITE_ASSET__rdDdfVJO__"